import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  InputAdornment, TextField
} from '@mui/material';

import { useForm, useFormContext } from 'react-hook-form';

// 组件
import { SendSmsCodeButton } from '../../users/smsCode';

export default function SmsCodeInput(props) {
  const { doSendCode } = props;
  const [t] = useTranslation();

  const { register, watch, errors } = useFormContext();
  const phone = watch('phone');

  const handleSendCode = () => doSendCode(phone);
  return (
    <TextField label={t('share.form.code')} fullWidth margin="dense"
      name="code" required
      autoComplete="off"
      inputRef={register({ required: true, minLength: 3 })}
      error={Boolean(errors.code)}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" style={{ marginBottom: '24px' }} >
            <SendSmsCodeButton
              disabled={Boolean((phone || '').length === 0 || errors.phone)}
              doSendCode={handleSendCode}
            />
          </InputAdornment>
        )
      }}
    />
  );
}





